import React, {useMemo} from 'react'

import Task from "../../model2/task/task"
import FormRowFlex from "../../gd-form/form/form-flex/row"
import FormFlex from "../../gd-form/form/form-flex/form"
import StatusUpdateRequestModel from "./form-model"
import FormModel from "../../gd-form/common/form-model-manager"
import FieldFormElement from "../../fields3/render/form-elemnent"
import FormFieldError from "../../gd-form/common/form-error/form-field-error"
import ButtonSubmit from "../../gd-form/common/btn-submit/btn-submit-ui5"
import ModalV4HeaderWhite from "../../../app/ui/modal/v4/header-white/v4-header-white"

type Props = {
    params: {
        task : Task
    }
}

const debug = true
// const debug = "TaskStatusUpdateModal"

export default function TaskStatusUpdateModal(props:Props) {

    const stopPropagation = (e:React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
    }

    const closeModal = () => {
        gd.modal.hide()
    }

    const model = useMemo(()=>new StatusUpdateRequestModel({
        userId      : props.params.task.actionRequiredUserId,
        comments    : ''
    }, props.params.task), [props.params.task])

    const onSubmit = async (model: StatusUpdateRequestModel) => {
        debug && console.log(debug, 'onSubmit', model)

        await gd.api.Task.statusUpdateRequest(props.params.task, model).promise()

        gd.modal.hide()
    }

    const form = new FormModel(model, {
        onSubmit        : onSubmit,
        isFormChanged   : true,
    })

    const labelWidth = 150

    return (
        <div className="v4-container placement-middle" onClick={stopPropagation}>
            <ModalV4HeaderWhite className       = "center-title p-t-60"
                                titleClassName  = "m-t-10"
                                height          = {90}
                                title           = "Request status update"
                                onClose         = {closeModal}/>

            <FormFlex className="p-t-30 p-l-50 p-r-50 p-b-50">
                <FormRowFlex label={model.fields.userId.label} width={labelWidth}>
                    <div className="flex-column-left-top">
                        <FieldFormElement className="w-300" field={model.fields.userId} form={form}/>
                        <FormFieldError form={form} fieldId={model.fields.userId.fieldId}/>
                    </div>
                </FormRowFlex>

                <FormRowFlex label={model.fields.comments.label} width={labelWidth}>
                    <div className="flex-column-left-top">
                        <FieldFormElement className="comments-field w-300" field={model.fields.comments} form={form}/>
                        <FormFieldError form={form} fieldId={model.fields.comments.fieldId}/>
                    </div>
                </FormRowFlex>

                <FormRowFlex className="m-t-30" width={labelWidth}>
                    <ButtonSubmit form={form} size="36" label="Submit"/>
                </FormRowFlex>
            </FormFlex>
        </div>
    )
}